module.exports = __webpack_public_path__ + "img/1726035994661-screenshot-1726035945705.png.e2f940af.webp";